import { errorSnapshotFunctionCallback, nextSnapshotFunctionCallback } from "@/types/firebase";
import { collection, doc, query, addDoc, DocumentReference, Firestore, getDoc, getDocs, getFirestore, onSnapshot, deleteDoc } from "firebase/firestore";

export class DataAccessService {

  protected db?: Firestore;

  protected collectionName = 'defdata';

  constructor(collectionName: string) {
    this.collectionName = collectionName;
  }

  getSnaphostCollection(onNext: nextSnapshotFunctionCallback,
    onError: errorSnapshotFunctionCallback,
    onComplete: () => void) {
    return onSnapshot(query(this.getCollection()), onNext, onError, onComplete)
  }

  getCollection(collectionName?: string) {
    
    return collection(this.getDb(), !collectionName ? this.collectionName : collectionName);
  }

  getCollectionDocs(collectionName?: string) {
    
    return getDocs(this.getCollection(collectionName));
  }

  getById(docId: string, collectionName?: string) {
    return getDoc(doc(this.getDb(), !collectionName ? this.collectionName : collectionName, docId));
  }
  
  getByRef(ref: DocumentReference) {
    return getDoc(ref);
  }

  add(data: any) {
    return addDoc(this.getCollection(), data)
  }

  delete(ref: DocumentReference<any>) {
    return deleteDoc(ref)
  }

  protected getDb() {
    if (!this.db) {
      this.db = getFirestore();
    }
    return this.db
  }
}